// Modules
import React, { ReactNode, useEffect, useState } from 'react'
import { ThemeProvider } from '@dasa-health/alma-react'
import { Button } from '@dasa-health/components-react'

// Components
import { navTheme } from 'theme'
import { ACCESS_TYPE, useCurrentLaboratory } from 'redesign/hooks/useCurrentLaboratory'
import { SnackbarProvider } from 'redesign/context/snackbar'
import { CustomSnackbar } from 'redesign/components/molecules/CustomSnackbar'
import { ShoppingCart } from 'redesign/components/molecules/ShoppingCart'
import { CustonModalOrBootomSheet } from 'redesign/components/molecules/CustomModalOrBottomSheet'

import {
    Container,
    ContainerContent,
    Form,
    CustomLogo,
    Header,
    LogoNav,
    Content,
    Title,
    Subtitle,
    Footer,
    CalendarContainer,
    FormContainer,
    Illustrator,
} from './styles'

import logoNav from 'assets/logo.svg'
import calendar from 'assets/calendar.svg'
import exame from 'assets/exame.svg'
import { SINGLE_BRAND } from 'redesign/constants/templateSigleBrand'
import { STORAGE_CURRENT_LABORATORY } from 'constants/storageKeys'
import { CurrentLaboratoryType } from 'typings/auth'

type TemplateContainerProps = {
    children: ReactNode
    renderTemplateLogoNav?: boolean
}

export const TemplateSingleBrand = ({ children, renderTemplateLogoNav = true }: TemplateContainerProps) => {
    const { currentLaboratoryStorage, layoutType } = useCurrentLaboratory()
    const [title, setTitle] = useState('')
    const [subtitle, setSubtitle] = useState('')
    const [showModalOrBottomSheet, setShowModalOrBottomSheet] = useState(false)

    const currentLaboratory: CurrentLaboratoryType = JSON.parse(sessionStorage.getItem(STORAGE_CURRENT_LABORATORY)!) || null
    const currentLayout = currentLaboratory?.layoutType as ACCESS_TYPE | null

    const laboratory = currentLaboratory ? currentLaboratory : currentLaboratoryStorage
    const dataItemPositionModal = `LP ${laboratory?.name} - Modal carrinho`

    useEffect(() => {
        if (currentLayout) {
            setTitle(SINGLE_BRAND[currentLayout].title)
            setSubtitle(SINGLE_BRAND[currentLayout].subtitle)
        }
    }, [currentLayout])

    if (!layoutType) {
        return null
    }

    return (
        <SnackbarProvider>
            <Container>
                <Header>
                    <CustomLogo alt={laboratory?.name} src={laboratory?.image} />

                    <ShoppingCart currentLaboratory={laboratory?.name} setShowModalOrBottomSheet={setShowModalOrBottomSheet} />
                </Header>

                <ContainerContent bgColor={laboratory?.titleBgColor}>
                    <Content bgColor={laboratory?.titleBgColor}>
                        <Title>{title}</Title>
                        <Subtitle>
                            {subtitle}
                            <strong>{laboratory?.name}</strong>.
                        </Subtitle>
                        <CalendarContainer>
                            <Illustrator alt="illustrator" src={layoutType === ACCESS_TYPE.resultado ? exame : calendar} />
                        </CalendarContainer>
                    </Content>

                    <FormContainer>
                        <Form>
                            {renderTemplateLogoNav && <LogoNav alt="Logo Nav Dasa" src={logoNav} />}
                            {children}
                        </Form>

                        <Footer bgColor={laboratory?.titleBgColor}>
                            <p>Site protegido pelo reCAPTCHA.</p>

                            <a href="/">Confira aqui nossas configurações de cookies.</a>
                        </Footer>
                    </FormContainer>
                </ContainerContent>

                <CustonModalOrBootomSheet
                    setShowModal={setShowModalOrBottomSheet}
                    showBackButtonBottomSheet={false}
                    showCloseButtonModal={false}
                    showModal={showModalOrBottomSheet}
                    title="Você tem exames ou vacinas adicionados no carrinho"
                >
                    <p>
                        Para visualizar os itens no carrinho, acesse sua conta <strong>Nav Dasa.</strong>
                    </p>

                    <Button
                        data-current-service="Onboarding"
                        data-item-position={dataItemPositionModal}
                        data-item-text="Ok, entendi"
                        data-testid="modalButton"
                        fullWidth
                        onClick={() => setShowModalOrBottomSheet(false)}
                        size="default"
                        type="button"
                        variant="primary"
                    >
                        Ok, entendi
                    </Button>
                </CustonModalOrBootomSheet>

                <ThemeProvider theme={navTheme}>
                    <CustomSnackbar />
                </ThemeProvider>
            </Container>
        </SnackbarProvider>
    )
}
